import "./filtros.css";
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InputDate, Label, Boton, Input } from "asocomponents"
import { addFiltrosPagosSinFactura, addFiltroRapidoPagosSinFactura, setFiltrosCargados } from '../../../redux/filtroPagosSinFacturaSlice'
import BuscadorJuicios from "../Buscadores/BuscadorJuicios/BuscadorJuicios"
import ExportarExcel from "../ExportarExcel/ExportarExcel"
import { Link } from 'react-router-dom'

export default function FiltrosPagosSinFactura() {
  const dispatch = useDispatch()
  const fechaActual = new Date()
  const filtrosCargados = useSelector(state => state.rootReducer.filtrosPagosSinFactura.cargados)
  const dataGrillaFactura = useSelector(state => state.rootReducer.resultadoGrillaPagosSinFactura.dataGrillaFactura)
  const usuarioString = sessionStorage.getItem('usuario') ? JSON.parse(sessionStorage.getItem('usuario')) : null;
  const camposExportarExcel = ["fechaRegistro", "fechaVto", "nroRecibo", "procesoJudicial", "formaPago", "importe"]

  fechaActual.setDate(fechaActual.getDate() + 1);
  fechaActual.setHours(0, 0, 0, 0); // Establecer la hora, minutos, segundos y milisegundos a 0

  const fechaMenos365Dias = new Date()
  fechaMenos365Dias.setDate(fechaMenos365Dias.getDate() - 20)

  const [isOpen, setIsOpen] = useState(false)
  const [fechaVtoDesde, setFechaVtoDesde] = useState()
  const [fechaVtoHasta, setFechaVtoHasta] = useState()
  const [fechaGrabacionDesde, setFechaGrabacionDesde] = useState(fechaMenos365Dias.toISOString().split('T')[0])
  const [fechaGrabacionHasta, setFechaGrabacionHasta] = useState(fechaActual.toISOString().split('T')[0])
  const [cuitLetrado, setCuitLetrado] = useState(usuarioString?.usuario)
  const [idJuicio, setIdJuicio] = useState(-1)
  const [montoDesde, setMontoDesde] = useState('')
  const [montoHasta, setMontoHasta] = useState('')
  const [palabraBuscar, setPalabraBuscar] = useState()

  const handleFiltros = () => {
    const filtros = {
      cuitLetrado: cuitLetrado,
      fechaAltaInicio: fechaGrabacionDesde,
      fechaAltaFin: fechaGrabacionHasta,
      fechaVtoInicio: fechaVtoDesde,
      fechaVtoFin: fechaVtoHasta,
      idJuicio: idJuicio,
      monImporteFacDesde: montoDesde,
      monImporteFacHasta: montoHasta,
    }

    dispatch(addFiltrosPagosSinFactura(filtros))
    dispatch(setFiltrosCargados(!filtrosCargados))

    toggleMenu()
  }

  const handleFechaVtoDesde = (valor) => {
    setFechaVtoDesde(valor)
  }

  const handleFechaVtoHasta = (valor) => {
    setFechaVtoHasta(valor)
  }

  const handleFechaGrabacionDesde = (valor) => {
    setFechaGrabacionDesde(valor)
  }

  const handleFechaGrabacionHasta = (valor) => {
    setFechaGrabacionHasta(valor)
  }

  const handleMontoDesde = (valor) => {
    setMontoDesde(valor)
  }

  const handleMontoHasta = (valor) => {
    setMontoHasta(valor)
  }

  const handlePalabraBuscar = (valor) => {
    setPalabraBuscar(valor)
    if (valor.length > 3) {
      dispatch(addFiltroRapidoPagosSinFactura(valor))
    }
    else {
      dispatch(addFiltroRapidoPagosSinFactura(''))
    }
  }
  const handleJuicio = async (juicio) => {
    setIdJuicio(juicio.idJuicio)
    setIsOpen(isOpen)
  }

  const toggleMenu = () => {
    setIsOpen(!isOpen)
    localStorage.setItem("filtrosOpen", (!isOpen).toString())
  }

  useEffect(() => {
    handleFiltros()
  }, [])

  return (
    <>
      <div className="flex flex-row justify-between m-3 w-[99%]">
        <div className="flex justify-start">
          <Input placeholder="Buscar" type="text" valor={palabraBuscar} onChange={handlePalabraBuscar} width="w-44" /> <Boton icono="filtro" onClick={toggleMenu} alt="Ver Filtros" colorIcon="#5a5a5a" />
        </div>
      </div>
      <div className={`overlay ${!isOpen ? "open" : ""}`} onClick={toggleMenu}></div>
      <div className={`floating-filtros ${isOpen ? "open" : ""}`}>
        <div className="filtros-content">
          <div className="flex flex-row justify-between items-center">
            <Label texto="FILTROS" size="text-m" /> <Boton icono="quitar" onClick={toggleMenu} alt="Cerrar" />
          </div>
          <div><hr /></div>
          <div className="flex flex-col mt-8">
            <div className="flex flex-row ml-5">
              <div className="text-left w-[50%]">
                <Label texto="Fecha Grab. Desde" />
              </div>
              <div className="text-left w-[50%]">
                <Label texto="Fecha Grab. Hasta" /></div>
            </div>
            <div className="flex flex-row">
              <div className="text-left w-[50%]">
                <InputDate valor={fechaGrabacionDesde} onChange={handleFechaGrabacionDesde} />
              </div>
              <div className="text-left w-[50%]">
                <InputDate valor={fechaGrabacionHasta} onChange={handleFechaGrabacionHasta} />
              </div>
            </div>
            <div className="flex flex-row ml-5 mt-3">
              <div className="text-left w-[50%]">
                <Label texto="Fecha Vto. Desde" />
              </div>
              <div className="text-left w-[50%]">
                <Label texto="Fecha Vto. Hasta" /></div>
            </div>
            <div className="flex flex-row">
              <div className="text-left w-[50%]">
                <InputDate valor={fechaVtoDesde} onChange={handleFechaVtoDesde} />
              </div>
              <div className="text-left w-[50%]">
                <InputDate valor={fechaVtoHasta} onChange={handleFechaVtoHasta} />
              </div>
            </div>
            <div className="flex flex-row ml-5 mt-3">
              <div className="text-left w-[50%]">
                <Label texto="Importe Desde" />
              </div>
              <div className="text-left w-[50%]">
                <Label texto="Importe Hasta" /></div> 
            </div>
            <div className="flex flex-row">
              <div className="text-left w-[50%] ml-3">
                <Input type="number" valor={montoDesde} onChange={handleMontoDesde} width="w-32" />
              </div>
              <div className="text-left w-[50%]">
                <Input type="number" valor={montoHasta} onChange={handleMontoHasta} width="w-32" />
              </div>
            </div>
            <div className="flex flex-row ml-5 mt-3">
              <div className="text-left w-[50%]">
                <Label texto="P. Judicial" />
              </div>
              <div className="text-left w-[50%]">
              </div>
            </div>
            <div className="flex flex-row">
              <div className="text-left w-[50%] ml-3">
                <BuscadorJuicios onChange={handleJuicio} cuitLetrado={cuitLetrado} width="w-20" referente="judicial" />
              </div>
              <div className="text-left w-[50%]">
              </div>
            </div>
            <div className="flex flex-row ml-5 mt-6 mb-3 justify-center items-center">
              <Boton texto="Aplicar" fondo="rojo" onClick={handleFiltros} alt="Buscar" height="h-8" />
            </div>

          </div>
        </div>
      </div>
      <div className="flex flex-col justify-end">
        <div className="flex flex-row justify-end m-4">
          <Link to={"../nuevopago"}><Boton texto="Nuevo Pago" type="button" fondo="rojo" width="w-32" height="h-9" /></Link>
        </div>
        <div className="flex justify-end mr-5">
          <ExportarExcel data={dataGrillaFactura} nombreArchivo={"ReportePagosSinFactura"} camposSeleccionados={camposExportarExcel} />
        </div></div>
    </>
  )
}
